/* eslint-disable */
import http from '@/utils/http';
import apiConfig from '../../../config/api';
const getApiPath = () => (apiConfig[`${PROCESS_ENV || 'DEV'}_API_ROOT`]);






export const getQRcode=async (inviterParentId,inviterStudentId)=>{

return await http.apiGet(`${getApiPath()}/library/unlimitedQrCode/${inviterParentId}/${inviterStudentId}`);
}
